var map = {
	"./Logo-wf-white.png": 6105,
	"./Logo-wf.png": 5763,
	"./fb-w.png": 215,
	"./fb.png": 2618,
	"./footer-bg.png": 6500,
	"./ig-w.png": 6790,
	"./ig.png": 9962,
	"./ln-w.png": 1198,
	"./ln.png": 8739,
	"./tt-w.png": 8218,
	"./tt.png": 6427,
	"./yt-w.png": 8098,
	"./yt.png": 4328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;